import React from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { GET_PROJECT } from "../graphql/queries";
import { NavLink } from "react-router-dom";
import { ROUTES } from "../routes/routes";
export default function Projectdetail() {
    const { slug } = useParams();
    const { loading, error, data } = useQuery(GET_PROJECT, {
        variables: { slug },
    });

    if (loading) return <p>Loading...</p>;
    if (error)
        return (
            <p>
                Error: {error.message} (Slug: {slug})
            </p>
        );

    if (!data || !data.portfolios || data.portfolios.length === 0) {
        return <p>No project found.</p>;
    }
    return data.portfolios.map((project) => (
        <div key={project.id} className="main-container">
            <div className="go-back">
                <NavLink to={ROUTES.project.path}> go back </NavLink>
            </div>
            <div className="detail-header">
                <div className="detail-header-conent">
                    <h1 className="detail-titles">{project.title}</h1>
                    <p className="detail-author"></p>
                </div>
                <img alt={project.title} src={project.image.url} />
            </div>
            <br />
            <p>{project.description}</p>
            <p>{project.date}</p>
            <br />
        </div>
    ));
}
